module.exports = __webpack_public_path__ + "static/media/lighthouse-bg.f5c85d64.png";